<template>
  <div class="techCenter" :style="{ minHeight: getClientHeight + 'px' }">
    <div class="header">
      <div v-show="curTab == 1" class="tab_1">
        <div class="tab_1_header">
          <div class="tab_1_header_r">
            <img src="../../assets/004a/banner2.png" alt="banner" />
          </div>
          <img src="../../assets/004a/logo.png" alt class="tab_1_logo" />
          <img src="../../assets/004a/004txt-01.png" alt class="tab_1_title" />
        </div>
        <div class="tab_1_mid">
          <div class="tab_1_mid_r">
            <img src="../../assets/004a/banner3.png" alt="banner" />
          </div>
          <img src="../../assets/004a/2.png" alt="banner" class="tab_1_2" />
          <img src="../../assets/004a/QA.png" alt="banner" class="tab_1_QA" />
        </div>
        <div class="tab_1_bottom">
          <!-- <div class='tab_1_bottom_r'>
                        <img src="../../assets/004a/banner1.png" alt="banner">
          </div>-->
          <img
            src="../../assets/004a/line.png"
            alt="banner"
            class="tab_1_line"
          />
        </div>
      </div>
      <div v-show="curTab == 2" class="tab_2">
        <div class="tab_2_header">
          <div class="tab_2_header_r">
            <img src="../../assets/004a/banner2.png" alt="banner" />
          </div>
          <img src="../../assets/004a/logo.png" alt class="tab_1_logo" />
          <img src="../../assets/004a/004txt-02.png" alt class="tab_1_title" />
        </div>
        <div class="tab_2_mid">
          <div class="tab_2_mid_r">
            <img src="../../assets/004a/004-ban-2.jpg" alt="banner" />
          </div>
        </div>
        <div class="tab_2_bottom">
          <!-- <div class='tab_2_bottom_r'>
                        <img src="../../assets/004a/banner1.png" alt="banner">
          </div>-->
          <img
            src="../../assets/004a/line.png"
            alt="banner"
            class="tab_1_line"
          />
        </div>
      </div>
      <div v-show="curTab == 3" class="tab_2">
        <div class="tab_2_header">
          <div class="tab_2_header_r">
            <img src="../../assets/004a/banner2.png" alt="banner" />
          </div>
          <img src="../../assets/004a/logo.png" alt class="tab_1_logo" />
          <img src="../../assets/004a/004txt-03.png" alt class="tab_1_title" />
        </div>
        <div class="tab_2_mid">
          <div class="tab_2_mid_r">
            <img src="../../assets/004a/004-ban-3.jpg" alt="banner" />
          </div>
        </div>
        <div class="tab_2_bottom">
          <!-- <div class='tab_2_bottom_r'>
                        <img src="../../assets/004a/banner1.png" alt="banner">
          </div>-->
          <img
            src="../../assets/004a/line.png"
            alt="banner"
            class="tab_1_line"
          />
        </div>
      </div>
      <div v-show="curTab == 4" class="tab_2">
        <div class="tab_2_header">
          <div class="tab_2_header_r">
            <img src="../../assets/004a/banner2.png" alt="banner" />
          </div>
          <img src="../../assets/004a/logo.png" alt class="tab_1_logo" />
          <img src="../../assets/004a/004txt-04.png" alt class="tab_1_title" />
        </div>
        <div class="tab_2_mid">
          <div class="tab_2_mid_r">
            <!-- <img src="../../assets/004a/004-ban-1.jpg" alt="banner"> -->
          </div>
        </div>
        <div class="tab_2_bottom">
          <!-- <div class='tab_2_bottom_r'>
                        <img src="../../assets/004a/banner1.png" alt="banner">
          </div>-->
          <img
            src="../../assets/004a/line.png"
            alt="banner"
            class="tab_1_line"
          />
        </div>
      </div>
      <!-- <img src="../../assets/khk004a.jpg" alt="banner" class='banner' v-show='curTab == 1'> -->
      <!-- <img src="../../assets/khk004b.jpg" alt="banner" class='banner' v-show='curTab == 2'> -->
      <!-- <img src="../../assets/khk004c.jpg" alt="banner" class='banner' v-show='curTab == 3'> -->
      <!-- <img src="../../assets/khk004d.png" alt="banner" class='banner' v-show='curTab == 4'> -->
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo" />
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back" />
        </router-link>
      </div>
      <div class="swiperBox" v-show="curTab == 4">
        <div id="swiper">
          <div class="imgBox">
            <div class="imgDiv" v-for="(item, index) of imgList" :key="index">
              <img :src="item" />
            </div>
          </div>
        </div>
      </div>

      <!-- 选项卡 start -->
      <div class="tab">
        <ul>
          <li
            v-for="(item, index) of TabList"
            :key="index"
            :class="{ active: curTab == index + 1 }"
            @click="checkTab(index)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <!-- 选项卡 end -->
    </div>
    <div class="main" :class="{ active: isCurTab2 }">
      <div class="mask">
        <p
          v-html="
            techCenterInfoItem ? techCenterInfoItem.copy_writing_content : ''
          "
        >
          {{
            techCenterInfoItem ? techCenterInfoItem.copy_writing_content : ""
          }}
        </p>
      </div>
      <!-- 齿轮问答内容部分 start -->
      <div class="part_1" v-show="curTab == 1">
        <div class="search">
          <input
            type="text"
            placeholder="输入关键词快速搜索"
            v-model="searchQuestionValue"
          />
          <span @click="searchQuestions">搜索</span>
        </div>
        <div class="search_result">
          <div class="search_result_left">
            <ul>
              <li
                v-for="(item, index) of questionTypeList"
                :key="index"
                :class="{ active: curQuestTab == item.id }"
                @click="checkQuestTab(item)"
              >
                {{ item.quesstion_category_name }}
              </li>
            </ul>
          </div>
          <div class="search_result_right">
            <ul>
              <li v-for="(item, index) of answerList" :key="index">
                <h3 class="q">{{ item.questions }}</h3>
                <p v-html="item.answers">{{ item.answers }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 齿轮问答内容部分 end -->

      <!-- 图纸下载内容部分 start -->
      <div class="part_2" v-show="curTab == 2">
        <div class="part_2_left">
          <div class="search">
            <p>请先此输入产品型号，在根据需要查看相关齿轮图纸</p>
            <input
              type="text"
              placeholder="输入产品型号"
              v-model="searchValue"
            />
          </div>
          <div class="search_btn">
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
                target="_blank"
              >
                <span>2D 图纸下载</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/dxf?product=' +
                  searchValue +
                  '&sun=False'
                "
                target="_blank"
              >
                <span>CAD 图纸下载</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=' +
                  searchValue
                "
                target="_blank"
              >
                <span>3D 图纸下载</span>
              </a>
            </div>
            <!-- <div class='downlo_2d'>
                            <select name="public-choice" class='fast_seearch_select' v-model="selectValue">
                                <option value='' disabled selected style='display:none;'>选择CAD扩展名</option>                                    
                                <option value="2d">2D</option>    
                                <option value="3d">3D</option>    
                            </select>    
                        </div>    
                        <div class='download_btn btn' @click="zoutFFWk('3D 图纸下载')">
                                <span>下载 2D CAD / 3D CAD</span>
            </div>-->
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
                target="_blank"
              >
                <span>强度计算</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
                target="_blank"
              >
                <span>追加工制图</span>
              </a>
            </div>
          </div>
        </div>
        <div class="part_2_right">
          <div class="download">
            <div class="download_btn" @click="showModalpdf">
              <div>
                <span>各国材料及精度等级对照表查阅</span>
                <img src="../../assets/pdf_img.png" alt />
              </div>
            </div>
            <div class="download_btn btn">
              <a href="https://khkgears.net/new/" target="_blank">
                <span>Gear Drawing 英文站</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 图纸下载内容部分 end -->
      <!-- 计算公式内容部分 start -->
      <div class="part_3" v-show="curTab == 3">
        <div class="mt">
          <div class="down">
            <a :href="fileinfo2" download target="_blank">
              <span>所有公式打包下载</span>
              <img src="../../assets/pdf_img.png" alt />
            </a>
          </div>
          <div class="mt_select">
            <h3>请在下方选择不同公式快速预览</h3>
            <!-- 1标准齿轮的计算表.jpg
                            2齿数的求法.jpg
                            3变位正齿轮的计算.jpg
                            4变位齿轮的计算.jpg
                            5齿条与变位正齿轮的啮合计算.jpg
                            6变位内齿轮和正齿轮的计算.jpg
                            7变位内齿轮和正齿轮的计算.jpg
                            8齿直角方式变位斜齿齿轮的计算.jpg
                            9齿直角方式斜齿条的计算.jpg
                            10轴直角方式斜齿齿条的计算.jpg
                            11格里森直齿锥齿轮的计算.jpg
                            12标准直齿锥齿轮的计算.jpg
                            13格里森弧齿锥齿轮的计算.jpg
                            14齿直角方式变位交错轴斜齿齿轮的计算.jpg
                            15轴向模数方式蜗杆蜗轮的计算.jpg
                            16齿直角方式蜗杆蜗轮的计算.jpg
                            17方便的力学换算式.jpg
            计算公式.pdf-->
            <select
              name="public-choice"
              class="fast_search_select"
              v-model="selectTechValue"
              @onChange="getSelectTechValue"
            >
              <option value disabled selected style="display: none">
                请选择您需要预览的公式
              </option>
              <option value="标准齿轮的计算表">标准齿轮的计算表</option>
              <option value="齿数的求法">齿数的求法</option>
              <option value="变位正齿轮的计算">变位正齿轮的计算</option>
              <option value="变位齿轮的计算">变位齿轮的计算</option>
              <option value="齿条与变位正齿轮的啮合计算">
                齿条与变位正齿轮的啮合计算
              </option>
              <option value="变位内齿轮和正齿轮的计算">
                变位内齿轮和正齿轮的计算
              </option>
              <option value="变位内齿轮和正齿轮的计算">
                变位内齿轮和正齿轮的计算
              </option>
              <option value="齿直角方式变位斜齿齿轮的计算">
                齿直角方式变位斜齿齿轮的计算
              </option>
              <option value="齿直角方式斜齿条的计算">
                齿直角方式斜齿条的计算
              </option>
              <option value="轴直角方式斜齿齿条的计算">
                轴直角方式斜齿齿条的计算
              </option>
              <option value="格里森直齿锥齿轮的计算">
                格里森直齿锥齿轮的计算
              </option>
              <option value="标准直齿锥齿轮的计算">标准直齿锥齿轮的计算</option>
              <option value="格里森弧齿锥齿轮的计算">
                格里森弧齿锥齿轮的计算
              </option>
              <option value="齿直角方式变位交错轴斜齿齿轮的计算">
                齿直角方式变位交错轴斜齿齿轮的计算
              </option>
              <option value="轴向模数方式蜗杆蜗轮的计算">
                轴向模数方式蜗杆蜗轮的计算
              </option>
              <option value="齿直角方式蜗杆蜗轮的计算">
                齿直角方式蜗杆蜗轮的计算
              </option>
              <option value="方便的力学换算式">方便的力学换算式</option>
            </select>
          </div>
        </div>
        <div class="part_img">
          <p>
            <span>当前预览:</span>
            {{ selectTechValue }}
          </p>
          <div class="res_img">
            <img
              :src="
                selectTechValue
                  ? require('../../assets/' + selectTechValue + '.jpg')
                  : '#'
              "
              alt
            />
          </div>
        </div>
      </div>
      <!-- 计算公式内容部分 end -->
      <!-- 计算公式内容部分 start -->
      <div class="part_4" v-show="curTab == 4">
        <ul>
          <li v-for="(item, index) of gearModuleList" :key="index">
            <video
              :src="item.image_vedio_address"
              v-if="item.image_vedio_type == 3"
              controls="controls"
              @play="playVideo"
              poster="../../assets/004txt-应用.png"
            ></video>
            <img
              :src="item.image_vedio_address"
              alt
              v-if="item.image_vedio_type == 1"
            />
            <div class="name">
              <h3>{{ item.gear_module_name }}</h3>
              <div v-if="item.image_vedio_type == 1">
                <p>使用产品</p>
                <span>{{ item.gear_module_explain }}</span>
              </div>
            </div>
          </li>
          <!-- <li>
                       <img src="https://dummyimage.com/480/f69" alt="">
                        <div class='name'>
                            <h3>包装机</h3>
                            <p>使用产品</p>
                            <span>SS / PS正齿轮</span>
                        </div>
                    </li>
                    <li>
                       <img src="https://dummyimage.com/480/f69" alt="">
                        <div class='name'>
                            <h3>搬送装置</h3>
                            <p>使用产品</p>
                            <span>SS正齿轮 / SR齿条</span>
                        </div>
                    </li>
                    <li>
                       <img src="https://dummyimage.com/480/f69" alt="">
                        <div class='name'>
                            <h3>搬送装置</h3>
                            <p>使用产品</p>
                            <span>KRG齿条 / SSG齿条</span>
                        </div>
                    </li>
                    <li>
                        <video src="../../assets/video.mp4" class='vide' controls="controls"></video>
                        <div class='name'>
                            <h3>齿轮齿条自动润滑系统装置</h3>
                        </div>
          </li>-->
        </ul>
      </div>
      <!-- 计算公式内容部分 end -->
    </div>
    <div class="modal-backdrop" v-show="showModal" @click="closeModal">
      <div class="modal" id="modal" :class="{ active: modalType == 2 }">
        <div class="modal-close" @click="closeModalCuspor">X</div>

        <div class="modal-header">{{ titleText || "提示" }}</div>
        <div class="modal-body">
          <img :src="PreviewPath" alt v-if="showModalType == 3" />
          <iframe
            id="mainContent"
            width="100%"
            height="100%"
            v-if="showModalType == 1"
          ></iframe>
        </div>
        <!-- <div class="modal-footer">
                    <button type="button" class="btn-close" @click="close" v-if="showCancle">{{cancleText?cancleText : '取消'}}</button>
                    <button type="button" class="btn-confirm" @click="confirm">{{confirmText ? confirmText : '确定'}}</button>
        </div>-->
      </div>
    </div>
    <mb-fotter :class="{ active: isCurTab2 }"></mb-fotter>
    <div class="banner_img" v-if="curTab == 1">
      <img src="../../assets/techs2.png" alt />
    </div>
    <div class="banner_img_1" v-if="curTab == 1">
      <img src="../../assets/techs3.png" alt />
    </div>
    <div class="banner_img_3" v-if="curTab == 2">
      <img src="../../assets/blo6.png" alt />
    </div>
    <div class="banner_img_4" v-if="curTab == 2">
      <img src="../../assets/blo7.png" alt />
    </div>
    <div class="banner_img_6" v-if="curTab >= 3">
      <img src="../../assets/techs4.png" alt />
    </div>
    <div class="banner_img_5" v-if="curTab >= 3">
      <img src="../../assets/techs5.png" alt />
    </div>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import request from "../../server/request.js";

export default {
  data() {
    return {
      curTab: this.$route.params.id,
      searchQuestionValue: "",
      isCurTab2: false,
      showCancle: false,
      confirmText: "确认发送",
      showModal: false,
      modalType: 1,
      titleText: "样册索取",
      searchValue: "",
      selectValue: "",
      selectTechValue: "标准齿轮的计算表",
      curQuestTab: "",
      showModalType: 1,
      imgList: [
        require("../../assets/a01.jpg"),
        require("../../assets/a02.jpg"),
        require("../../assets/a03.jpg"),
        require("../../assets/a04.jpg"),
        require("../../assets/a05.jpg"),
        require("../../assets/a06.jpg"),
        require("../../assets/a07.jpg"),
        require("../../assets/a08.jpg"),
        require("../../assets/a09.jpg"),
        require("../../assets/a10.jpg"),
        require("../../assets/a11.jpg"),
      ],
      TabList: ["齿轮问答", "图纸下载", "计算公式", "齿轮应用"],
      questionTypeList: [],
      answerList: [],
      techCenterInfoItem: {},
      techCenterInfoList: [],
      fileinfo1: "",
      fileinfo2: "",
      PreviewPath: "",
      gearModuleList: [],
      getClientHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      timer: null,
    };
  },
  methods: {
    move() {
      let imgBox = document.getElementsByClassName("imgBox")[0];
      imgBox.innerHTML += imgBox.innerHTML;
      let imgDiv = document.getElementsByClassName("imgDiv");
      imgBox.style.width = imgDiv.length * this.imgWidth + "px";
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (imgBox.offsetLeft < -(imgBox.offsetWidth / 2 - 364)) {
          //向左滚动
          imgBox.style.left = 0;
        }
        imgBox.style.left = imgBox.offsetLeft + -Math.abs(1) + "px";
      }, 30);
    },
    closeModalCuspor() {
      this.showModal = false;
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    checkQuestTab(item) {
      this.curQuestTab = item.id;
      request.getQuestionsById(item.id, (res) => {
        this.answerList = res.data;
      });
    },
    showModalpdf() {
      this.showModal = true;
      this.showModalType = 3;
      this.modalType = 2;
      this.titleText = "各国材料及精度等级对照表查阅";
      this.PreviewPath = require("../../assets/new.jpg");
    },
    // zoutFFWk(type) {
    //     this.showModal = true;
    //     this.titleText = type;
    //     const mainContent = document.getElementById('mainContent');
    //     switch (type) {
    //         case '2D 图纸下载':
    //             mainContent.src = 'https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=' + this.searchValue + '&lang=zh_CN'
    //             break;
    //         case '3D 图纸下载':
    //             mainContent.src = 'https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=' + this.searchValue
    //             break;
    //         case '强度计算':
    //             mainContent.src = 'https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=' + this.searchValue + '&lang=zh_CN'
    //             break;
    //         case '追加工制图':
    //             mainContent.src = 'https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=' + this.searchValue + '&lang=zh_CN'
    //             break;
    //         default:
    //             break;
    //     }
    // },
    confirm() {
      this.showModal = false;
    },
    checkTab(index) {
      this.curTab = index + 1;
      switch (Number(index + 1)) {
        case 1:
          this.isCurTab2 = false;
          this.beforeDestroy();
          this.techCenterInfoItem = this.techCenterInfoList.filter(
            (item) => item.copy_writing_type == "TechCenter_QA"
          )[0];
          break;
        case 2:
          this.isCurTab2 = true;
          this.beforeDestroy();
          this.techCenterInfoItem = this.techCenterInfoList.filter(
            (item) => item.copy_writing_type == "TechCenter_Down"
          )[0];
          break;
        case 3:
          this.isCurTab2 = false;
          this.beforeDestroy();
          this.techCenterInfoItem = this.techCenterInfoList.filter(
            (item) => item.copy_writing_type == "TechCenter_Calc"
          )[0];
          break;
        case 4:
          this.isCurTab2 = false;
          this.move();
          this.techCenterInfoItem = this.techCenterInfoList.filter(
            (item) => item.copy_writing_type == "TechCenter_Application"
          )[0];
          break;
        default:
          break;
      }
    },
    getSelectTechValue(e) {
      this.selectTechValue = e.target.value;
    },
    searchQuestions() {
      if (!this.searchQuestionValue) {
        alert("请输入关键词");
      } else {
        request.getSearchQuestions(this.searchQuestionValue, (res) => {
          this.answerList = res.data;
          this.curQuestTab = 0;
        });
      }
    },
    loadData() {
      request.getQuestionsType((res) => {
        if (res && res.errcode === 0) {
          this.questionTypeList = res.data;
          this.curQuestTab = res.data[0].id;
          request.getQuestionsById(res.data[0].id, (data) => {
            if (data && data.errcode === 0) {
              this.answerList = data.data;
            }
          });
        }
      });

      request.getFileDown((res) => {
        if (res && res.errcode === 0) {
          // this.fileList = res.data
          this.fileinfo1 = res.data.filter(
            (item) => item.file_location === "/khk004b"
          )[0].file_address;
          this.fileinfo2 = res.data.filter(
            (item) => item.file_location === "/khk004c"
          )[0].file_address;
        }
      });

      request.getGearModuleList((res) => {
        if (res && res.errcode === 0) {
          this.gearModuleList = res.data;
        }
      });

      request.getTechCenterInfo((res) => {
        this.techCenterInfoList = res.data;
        switch (Number(this.curTab)) {
          case 1:
            this.techCenterInfoItem = res.data.filter(
              (item) => item.copy_writing_type == "TechCenter_QA"
            )[0];
            break;
          case 2:
            this.techCenterInfoItem = res.data.filter(
              (item) => item.copy_writing_type == "TechCenter_Down"
            )[0];
            break;
          case 3:
            this.techCenterInfoItem = res.data.filter(
              (item) => item.copy_writing_type == "TechCenter_Calc"
            )[0];
            break;
          case 4:
            this.techCenterInfoItem = res.data.filter(
              (item) => item.copy_writing_type == "TechCenter_Application"
            )[0];
            break;
          default:
            break;
        }
      });
    },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
          this.showModalType = 1;
          this.modalType = 1;
        }
      }
    },
    playVideo() {
      const videos = document.getElementsByTagName("video");
      for (let i = videos.length - 1; i >= 0; i--) {
        (function () {
          var p = i;
          videos[p].addEventListener("play", function () {
            for (var j = videos.length - 1; j >= 0; j--) {
              if (j != p) videos[j].pause();
            }
          });
        })();
      }
    },
  },
  created() {
    this.loadData();
  },
  components: {
    mbFotter,
  },
  mounted() {
    if (this.$route.params.id && Number(this.$route.params.id) === 4) {
      this.move();
    }
    if (this.$route.params.id && Number(this.$route.params.id) === 2) {
      this.isCurTab2 = true;
    }
  },
};
</script>

<style lang="less" scoped>
.techCenter {
  position: relative;
  .banner_img {
    position: absolute;
    // width: 4.64rem;
    height: 17.2rem;
    right: 0;
    top: 20.4rem;
    img {
      width: 100%;
      height: 100%;
      background-size: 100%;
    }
  }
  .banner_img_1 {
    position: absolute;
    width: 6.4rem;
    height: 24rem;
    left: 0;
    top: 20.4rem;
    img {
      width: 100%;
    }
  }
  .banner_img_3 {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .banner_img_4 {
    position: absolute;
    left: 0;
    bottom: 140px;
  }
  .banner_img_5 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 8.64rem;
    img {
      width: 100%;
    }
  }
  .banner_img_6 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .header {
    position: relative;
    z-index: 1;
    background: #000;
    .tab_1 {
      .tab_1_header {
        .tab_1_header_r {
          width: 100%;
          position: relative;
          height: 60px;
          vertical-align: top;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .tab_1_logo {
          position: absolute;
          left: 2%;
          top: 12px;
        }
        .tab_1_title {
          position: absolute;
          left: 50%;
          top: 2px;
          margin-left: -144px;
        }
      }
      .tab_1_mid {
        .tab_1_mid_r {
          width: 100%;
          position: relative;
          height: 300px;
          img {
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .tab_1_2 {
          position: absolute;
          width: 214px;
          left: 50%;
          margin-left: -600px;
          top: 70px;
        }
        .tab_1_QA {
          position: absolute;
          width: 214px;
          left: 50%;
          margin-left: -260px;
          top: 160px;
        }
      }
      .tab_1_bottom {
        .tab_1_bottom_r {
          width: 100%;
          position: relative;
          height: 100px;
          img {
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .tab_1_line {
          position: absolute;
          left: 50%;
          margin-left: -620px;
          bottom: 40px;
        }
      }
    }
    .tab_2 {
      .tab_2_header {
        .tab_2_header_r {
          width: 100%;
          position: relative;
          height: 60px;
          vertical-align: top;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .tab_1_logo {
          position: absolute;
          left: 2%;
          top: 12px;
        }
        .tab_1_title {
          position: absolute;
          left: 50%;
          top: 2px;
          margin-left: -144px;
        }
      }
      .tab_2_mid_r {
        width: 100%;
        position: relative;
        height: 300px;
        img {
          width: 100%;
          object-fit: cover;
          height: 100%;
        }
      }
      .tab_2_bottom {
        margin-top: -3px;
        .tab_2_bottom_r {
          width: 100%;
          position: relative;
          height: 100px;
          img {
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .tab_1_line {
          position: absolute;
          left: 50%;
          margin-left: -620px;
          bottom: 40px;
          z-index: 2;
        }
      }
    }
    .banner {
      position: relative;
      width: 100%;
      height: 12rem;
      background-size: 100% 100%;
      vertical-align: top;
      z-index: 3;
    }
    .techs_img {
      position: absolute;
      left: 15%;
      bottom: 20%;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      padding: 0 1rem;
      height: 60px;
      z-index: 7;
      .logo {
        display: none;
      }
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }
    .img_list {
      position: absolute;
      left: 0;
      top: 80px;
      height: 300px;
      z-index: 1;
      width: 100%;
      overflow: hidden;
      ul {
        display: flex;
        height: 100%;
        li {
          width: 203px;
          height: 100%;
          transition: all 0.3s;
          &:hover {
            width: 480px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    .tab {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 6;
      ul {
        display: flex;
        height: 0.78rem;
        color: #fff;
        align-items: center;
        justify-content: center;
        li {
          width: 20%;
          text-align: center;
          height: 100%;
          line-height: 0.78rem;
          border: 1px solid rgba(128, 128, 128, 1);
          border-radius: 3px;
          font-size: 0.4rem;
          font-weight: 500;
          letter-spacing: 4px;
          background: #d9d9d9;
          color: #808080;
          cursor: pointer;
          &.active {
            transition: all 0.3s;
            color: #fff;
            background: #0583c9;
            border: 1px solid rgba(5, 131, 201, 1);
          }
        }
      }
    }
  }
  .main {
    // margin-left: 20%;
    background: #fff;
    padding-top: 0.1rem;
    padding-bottom: 0.6rem;
    .mask {
      width: 80%;
      margin: 0 auto;
      color: #0583c9;
      border-bottom: 1px dashed #0583c9;
      margin-bottom: 0.5rem;
    }
    &.active {
      padding-bottom: 3.6rem;
    }
    .part_1 {
      // padding-left: 20%;
      width: 80%;
      margin: 0 auto;
      .search {
        display: flex;
        input {
          width: 17.7%;
          height: 0.58rem;
          border-radius: 5px;
          border: 1px solid #0583c9;
          text-align: center;
          color: #666;
        }
        span {
          width: 1.2rem;
          height: 0.58rem;
          margin-left: 0.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #0583c9;
          border-radius: 5px;
          color: #fff;
          font-weight: 500;
          letter-spacing: 1px;
          cursor: pointer;
        }
      }
      .search_result {
        display: flex;
        width: 100%;
        position: relative;
        z-index: 20;
        .search_result_left {
          width: 27%;
          margin-right: 0.3rem;
          ul {
            display: flex;
            flex-direction: column;
            border-right: 1px solid #0583c9;
            background: #fff;
            margin-top: 0.3rem;
            li {
              width: 90%;
              // height: 0.68rem;
              height: 42px;
              border-radius: 5px;
              border: 1px solid #0583c9;
              text-align: center;
              line-height: 42px;
              font-size: 16px;
              // line-height: 0.68rem;
              margin-top: 0.3rem;
              position: relative;
              color: #0583c9;
              font-weight: 500;
              cursor: pointer;
              &:first-child {
                margin-top: 0;
              }
              &.active {
                background: #0583c9;
                color: #fff;
                transition: all 0.3s;
              }
              &.active::before {
                content: "";
                width: 0;
                height: 0;
                position: absolute;
                right: -11.5%;
                top: 0.15rem;
                border-top: solid 8px transparent;
                border-right: solid 8px #0583c9;
                border-bottom: solid 8px transparent;
              }
            }
          }
        }
        .search_result_right {
          margin-left: 0.3rem;
          width: 52%;
          min-height: 1600px;
          // max-height: 2000px;
          // overflow-y: scroll;
          ul {
            display: flex;
            flex-direction: column;
            li {
              h3 {
                // font-size: 0.34rem;
                font-size: 20px;
                font-weight: 500;
                color: #0583c9;
              }
              p {
                margin-left: 1rem;
                // font-size: 0.3rem;
                font-size: 18px;
                color: #333;
                font-weight: 450;
                line-height: 1.5;
              }
            }
          }
        }
      }
    }
    .part_2 {
      display: flex;
      padding: 0 10%;
      position: relative;
      z-index: 10;
      .part_2_left {
        display: flex;
        border-right: 1px solid #0583c9;
        // width: 56.5%;
        padding-right: 65px;
        .search {
          display: flex;
          flex-direction: column;
          margin-right: 0.9rem;
          width: 75%;
          p {
            color: #0583c9;
            font-weight: 500;
            font-size: 0.32rem;
          }
          input {
            width: 100%;
            text-align: center;
            color: #bdbdbd;
            border: 1px solid #939393;
            height: 0.6rem;
            border-radius: 5px;
          }
        }
        .search_btn {
          display: flex;
          flex-direction: column;
          width: 7rem;
          margin-top: 1rem;
          .download_btn {
            display: flex;
            align-items: center;
            border: 1px solid #0583c9;
            justify-content: center;
            width: 100%;
            // height: 1.68rem;
            height: 42px !important;
            border-radius: 5px;
            padding: 0.1rem 0;
            margin-bottom: 0.5rem;
            background: #fff;
            color: #0583c9;
            // font-size: 0.28rem;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.5;
            cursor: pointer;

            &.btn {
              height: auto;
              padding: 0.1rem 0;
              a {
                color: #0583c9;
                span {
                  width: 100%;
                  text-align: center;
                  letter-spacing: 1px;
                }
              }
            }
            a {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                width: 38%;
                display: inline-block;
                margin-right: 10px;
              }
              img {
                width: 20%;
                height: 100%;
              }
            }
          }
          .fast_seearch_h3 {
            color: #0583c9;
          }
          .fast_seearch_input {
            width: 100%;
            padding: 0.1rem 0;
            margin-bottom: 0.5rem;
            border-radius: 5px;
            border: 1px solid #ccc;
            text-align: center;
            height: auto;
            height: 0.78rem;
            color: #333;
          }
          .downlo_2d {
            width: 100%;
            .fast_seearch_select {
              width: 100%;
              background: #fff;
              margin-bottom: 0.2rem;
              height: 0.68rem;
              color: #bdbdbd;
              text-align: center;
              option {
                text-align: center;
              }
            }
          }
        }
      }
      .part_2_right {
        // width: 29%;
        margin-left: 1.2rem;
        .download {
          .download_btn {
            display: flex;
            align-items: center;
            border: 1px solid #0583c9;
            justify-content: center;
            width: 100%;
            height: 1.64rem;
            background: #fff;
            border-radius: 5px;
            padding: 0.1rem 0;
            margin-bottom: 0.5rem;
            color: #0583c9;
            font-size: 0.28rem;
            font-weight: 500;
            line-height: 1.5;
            cursor: pointer;

            &.btn {
              height: auto;
              padding: 0.1rem 0;
              a {
                color: #0583c9;
                span {
                  width: 100%;
                  text-align: center;
                  letter-spacing: 1px;
                }
              }
            }
            div {
              width: 100%;
              display: flex;
              align-items: center;
              background: #fff;
              justify-content: center;
              color: #0583c9;
              span {
                width: 40%;
                display: inline-block;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    .part_3 {
      // padding-left: 10%;
      width: 80%;
      margin: 0 auto;
      .mt {
        width: 90%;
        display: flex;
        margin-top: 0.9rem;
        border-bottom: 1px solid #0583c9;
        padding-left: 15%;
        padding-bottom: 0.6rem;
        .down {
          display: flex;
          align-items: center;
          border: 1px solid #0583c9;
          justify-content: center;
          width: 4.7rem;
          height: 1.64rem;
          border-radius: 5px;
          margin-bottom: 0.5rem;
          color: #0583c9;
          font-size: 0.28rem;
          font-weight: 500;
          line-height: 1.5;
          cursor: pointer;
          a {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.1rem 0;
            color: #0583c9;
            span {
              width: 30%;
              display: inline-block;
              margin-right: 0.6rem;
              margin-left: 0.8rem;
            }
          }
        }
        .mt_select {
          width: 40%;
          margin-left: 1.9rem;
          h3 {
            color: #0583c9;
          }
          .fast_search_select {
            width: 100%;
            padding: 0.1rem 0;
            margin-bottom: 0.5rem;
            border-radius: 5px;
            border: 1px solid #ccc;
            text-align: center;
            height: auto;
            height: 0.64rem;
            color: #333;
          }
        }
      }
      .part_img {
        min-height: 12rem;
        margin-left: 25%;
        margin-top: 0.9rem;
        margin-bottom: 2rem;

        p {
          color: #0583c9;
          span {
            font-weight: 600;
            display: inline-block;
            margin-right: 10px;
          }
        }
        .res_img {
          width: 13.2rem;
          border: 1px solid rgba(215, 215, 215, 1);
          box-shadow: 7px 7px 0px 0px rgba(5, 131, 201, 0.2);
          position: relative;
          z-index: 10;
          background: #fff;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .part_4 {
      width: 80%;
      margin: 0 auto;
      ul {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        // justify-content: center;
        z-index: 10;
        li {
          width: 24%;
          margin-right: 1%;
          margin-bottom: 0.6rem;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 1),
            rgba(5, 131, 201, 1)
          );
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 100%;
            background-size: 100%;
          }
          video {
            width: 100%;
            // height: 3.6rem;
            background-size: 100%;
            outline: none;
          }
          .name {
            margin-left: 0.2rem;
            padding-bottom: 0.2rem;
            h3 {
              font-size: 0.3rem;
              margin-top: 0.1rem;
              color: #fff;
            }
            p,
            span {
              color: #fff;
              margin-bottom: 0.05rem;
            }
          }
          .vide {
            width: 100%;
            outline: none;
          }
        }
      }
    }
  }
  .swiperBox {
    position: absolute;
    left: 0;
    top: 60px;
    height: 300px;
    z-index: 1;
    width: 100%;
    overflow: hidden;
    #swiper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      .imgBox {
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 300px;
        z-index: 1;
        .imgDiv {
          height: 100%;
          background-size: 100%;
          cursor: pointer;
          object-fit: cover;
          min-width: 160px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 15px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      width: 1200px;
      background: #fff;
      position: relative;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      max-height: 710px;
      overflow: scroll;
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      &.active {
        width: 500px;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: center;
        padding: 0.3rem 0 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        #mainContent {
          border: none;
          min-height: 800px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .fotter.active {
    position: absolute;
  }
}
</style>
